import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import menu from '../Data/Menu/menu.json';
import { Toaster } from 'react-hot-toast';
import { usePermissions } from "../../context/AuthContext";
import axios from "axios";

function Sidebar() {
    const navigate = useNavigate();
    const location = useLocation();
    const { can, privileges } = usePermissions();

    const [isSidebarMini, setIsSidebarMini] = useState(false);
    const [menuData, setMenuData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeKey, setActiveKey] = useState(location.pathname);
    const [ticketCounts, setTicketCounts] = useState({ userOpenTickets: 0, astrologerOpenTickets: 0 });

    const fetchTicketCounts = async () => {
        try {
            const token = localStorage.getItem("vedhvidhi-admin-token");
            const response = await axios.get(`${process.env.REACT_APP_BASEURL}/admin/ticket?summary=true`, {
                headers: { Authorization: token },
            });
            if (response.data && response.data.success) {
                setTicketCounts(response.data.data);
            }
        } catch (error) {
            console.error("Failed to fetch ticket counts", error);
        }
    };

    useEffect(() => {
        fetchTicketCounts();
        const isSuperAdmin = privileges.includes('SUPER_ADMIN');

        if (isSuperAdmin) {
            setMenuData(menu.menu);
        } else {
            const filterMenu = (menuItems) => {
                const accessibleMenu = [];
                menuItems.forEach(item => {
                    if (item.children && item.children.length > 0) {
                        const visibleChildren = filterMenu(item.children);
                        if (visibleChildren.length > 0) {
                            accessibleMenu.push({ ...item, children: visibleChildren });
                        }
                    } else {
                        if (item.requiredPrivilege && can(item.requiredPrivilege)) {
                            accessibleMenu.push(item);
                        }
                    }
                });
                return accessibleMenu;
            };
            const accessibleMenu = filterMenu(menu.menu);
            setMenuData(accessibleMenu);
        }
        setLoading(false);
    }, [can, privileges]);

    useEffect(() => {
        setActiveKey(location.pathname);
    }, [location]);

    const openChildren = (id) => {
        const otherTabs = document.getElementsByClassName("has-children");
        if (otherTabs) {
            for (let i = 0; i < otherTabs.length; i++) {
                if (otherTabs[i].id !== id) {
                    otherTabs[i].className = otherTabs[i].className.replace(" show", "");
                    if (otherTabs[i].parentElement.children.length > 1) {
                        otherTabs[i].parentElement.children[0].setAttribute("aria-expanded", "false");
                    }
                }
            }
        }
        const menutab = document.getElementById(id);
        if (menutab) {
            if (menutab.classList.contains("show")) {
                menutab.classList.remove("show");
                if (menutab.parentElement.children.length > 1) {
                    menutab.parentElement.children[0].setAttribute("aria-expanded", "false");
                }
            } else {
                menutab.classList.add("show");
                if (menutab.parentElement.children.length > 1) {
                    menutab.parentElement.children[0].setAttribute("aria-expanded", "true");
                }
            }
        }
    };

    const openChildren1 = (id) => {
        const otherTabs = document.getElementsByClassName("has-children");
        if (otherTabs) {
            for (let i = 0; i < otherTabs.length; i++) {
                otherTabs[i].className = otherTabs[i].className.replace(" show", "");
            }
        }
        const menutab = document.getElementById(id);
        if (menutab) {
            menutab.classList.add("show");
            if (menutab.parentElement.children.length > 1) {
                menutab.parentElement.children[0].setAttribute("aria-expanded", "true");
            }
        }
    };

    const handleClick = (route) => {
        setActiveKey(route);
        navigate(route);
        fetchTicketCounts();
    };

    const getDisplayName = (item) => {
        if (item.routerLink && item.routerLink[0] === 'user-feedback') {
            return `${item.name} (${ticketCounts.userOpenTickets || 0})`;
        }
        if (item.routerLink && item.routerLink[0] === 'astrologer-support') {
            return `${item.name} (${ticketCounts.astrologerOpenTickets || 0})`;
        }
        return item.name;
    };

    if (loading) {
        return <div style={{ width: '280px' }}></div>; // Placeholder
    }

    return (
        <>
            <Toaster position="top-center" reverseOrder={true} duration="10000" />
            <div id="mainsidemenu" className={`sidebar px-4 py-4 py-md-4 me-0 ${isSidebarMini ? "sidebar-mini" : ""}`} style={{ overflow: 'scroll' }}>
                <div className="d-flex flex-column h-100">
                    <Link to="/dashboard" className="mb-0 brand-icon">
                        <span className="logo-icon">
                            <i className="bi bi-bag-check-fill fs-4"></i>
                        </span>
                        <span className="logo-text">Ved-Vidhi</span>
                    </Link>
                    <ul className="menu-list flex-grow-1 mt-3">
                        {menuData?.map((d, i) => {
                            if (!d.children || d.children.length === 0) {
                                return (
                                    <li key={d.name + i} className="collapsed">
                                        <Link to={process.env.PUBLIC_URL + "/" + d.routerLink[0]}
                                            className={`m-link ${(activeKey.includes(d.routerLink[0])) ? "active" : ""}`}
                                            onClick={() => handleClick(process.env.PUBLIC_URL + "/" + d.routerLink[0])}>
                                            <i className={d.iconClass || 'icofont-dotted-right'}></i>
                                            <span>{getDisplayName(d)}</span>
                                        </Link>
                                    </li>
                                );
                            }
                            return (
                                <li key={d.name + i} className="collapsed">
                                    <a className={`m-link ${d.children?.some(c => activeKey.includes(c.routerLink[0])) ? "active" : ""}`} href="#!"
                                        onClick={(e) => {
                                            openChildren(`menu-Pages${i}`);
                                        }}>
                                        <i className={d.iconClass || 'icofont-dotted-right'}></i>
                                        <span>{getDisplayName(d)}</span>
                                        <span className="arrow icofont-dotted-down ms-auto text-end fs-5"></span>
                                    </a>
                                    {d.children.length > 0 &&
                                        <ul className="sub-menu collapse has-children" id={`menu-Pages${i}`}>
                                            {d.children.map((data, ind) => {
                                                if (activeKey.includes(data.routerLink[0])) {
                                                    setTimeout(() => {
                                                        openChildren1(`menu-Pages${i}`);
                                                    }, 500);
                                                }
                                                return (
                                                    <li key={data.name + ind}>
                                                        <Link
                                                            className={`${(activeKey.includes(data.routerLink[0])) ? "ms-link active" : "ms-link"}`}
                                                            to={process.env.PUBLIC_URL + "/" + data.routerLink[0]}
                                                            onClick={() => handleClick(process.env.PUBLIC_URL + "/" + data.routerLink[0])}>
                                                            <span>{getDisplayName(data)}</span>
                                                        </Link>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    }
                                </li>
                            );
                        })}
                    </ul>
                    <button type="button" className="btn btn-link sidebar-mini-btn text-light" onClick={() => { setIsSidebarMini(!isSidebarMini) }}>
                        <span className="ms-2"><i className="icofont-bubble-right"></i></span>
                    </button>
                </div>
            </div>
        </>
    );
}

export default Sidebar;